/**
 * useDriveInit — Exposes Drive resilience state to React components.
 *
 * Does NOT control initialization (that stays in App.tsx via ensureAppStructure).
 * Only reads state from driveConfig singleton for UI decisions (e.g. degraded banner).
 */

import { useSyncExternalStore } from 'react';
import { driveConfig, DriveInitState } from '../services/driveConfig';

export function useDriveInit(): {
  state: DriveInitState;
  isDegraded: boolean;
  isRecoveryNeeded: boolean;
} {
  const state = useSyncExternalStore(
    (listener) => driveConfig.subscribe(listener),
    () => driveConfig.getSnapshot()
  );

  return {
    state,
    isDegraded: state === 'degraded',
    isRecoveryNeeded: state === 'recovery-needed',
  };
}
